<nav class="navbar navbar-expand-lg lightDarkPurple">
  <div class="container-fluid customGapping">
    <a class="navbar-brand" href="#">
      <img
        src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/images/instaciti-logo.png"
        class="img-fluid logoWidth"
        alt="instacity-logo"
      />
    </a>

    <div class="listingSearch ms-5">
      <div class="row">
        <div class="col-md-12">
          <div class="input-group">
            <span class="input-group-text lightDarkPurple border-end-0">
              <img
                src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/icons/location-pin.svg"
                class="img-fluid"
                alt="location-icon"
              />
              <span class="font16 font500 ms-1 styled-select">
                <input
                  class="form-control customInput lightDarkPurple lightDarkPurple-focus border-0"
                  list="datalistOptions2"
                  [placeholder]="localityPlaceholder"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  name="searchText"
                  [(ngModel)]="searchText"
                  (keyup)="getNearBy()"
                  (focus)="focusLocation()"
                  autocomplete="off"
                />
                <ul
                  class="dropdown-menu p-3 serviceLocationDropdown"
                  aria-labelledby="dropdownMenuButton1"
                >
                  <li class="lightDarkPurple p-2 rounded customPurple">
                    <img
                      class="img-fluid"
                      src="../../../../assets/instaciti-new-img/Group 17.svg"
                      alt="location"
                    />
                    <span
                      class="locationText cursorPointer ms-2"
                      (click)="detectCurrentLocation()"
                      >Detect current location</span
                    >
                  </li>
                  <ng-container *ngIf="!searchText">
                    <p class="font18 font500 customPurple mt-3">
                      Popular cities
                    </p>
                    <ng-container *ngFor="let city of popularCities">
                      <li>
                        <a
                          class="dropdown-item cursorPointer"
                          (click)="selectPopularCity(city)"
                        >
                          <p class="listMuted mb-0">
                            {{ city.LocName }}
                          </p>
                        </a>
                      </li>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="searchText">
                    <p class="font18 font500 customPurple mt-3">
                      Nearby Location
                    </p>
                    <ng-container *ngFor="let city of nearby">
                      <li>
                        <a
                          class="dropdown-item cursorPointer"
                          (click)="selectNearByCity(city)"
                        >
                          <p class="listMuted mb-0">
                            {{
                              city.LocName && city.LocName.length > 50
                                ? (city.LocName | slice: 0:48) + ".."
                                : city.LocName
                            }}
                          </p>
                        </a>
                      </li>
                    </ng-container>
                  </ng-container>
                </ul>
              </span>
            </span>
            <input
              class="form-control customInput p-3 border-start-0 border-end-0"
              [placeholder]="placeholder"
              (keyup)="search($event)"
              (focus)="focus($event)"
              [matAutocomplete]="keywords"
              [(ngModel)]="selectedKeyWord.Keywd"
              [ngModelOptions]="{ standalone: true }"
            />
            <mat-autocomplete
              #keywords="matAutocomplete"
              (optionSelected)="onChange($event.option.value)"
            >
              <mat-option *ngFor="let item of searchResult" [value]="item">
                {{ item.Keywd }}
              </mat-option>
            </mat-autocomplete>

            <span class="input-group-text bg-white border-start-0"
              ><img
                src="../../../../assets/instaciti-new-img/Vector (5).svg"
                alt="location-icon"
              />
            </span>
          </div>
        </div>
      </div>
    </div>

    <a
      class="nav-link font14 font500 btn btn-sm custom-btnShadow text-white orangeGradientButton mobileViewDisaplay"
      target="_blank"
      href="http://join.instaciti.com/jff"
    >
      JOIN FOR FREE
    </a>
    <div
      class="collapse navbar-collapse desktopViewDisaplay"
      id="navbarSupportedContent"
    >
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item me-3 desktopViewDisaplay">
          <a
            class="nav-link font14 font500 btn btn-sm custom-btnShadow text-white orangeGradientButton"
            href="http://join.instaciti.com/jff"
            target="_blank"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            data-bs-html="true"
            title='
                          <div>Sign Up now & get your free signature
                              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                          </div>
                      '
          >
            JOIN FOR FREE
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<div
  class="container-fluid pt-5 pb-5 customGapping listingHero"
  [ngClass]="{
    restaurantHero: business === 'restaurant',
    beautyHero: business === 'beauty-spa',
    schoolsHero: business === 'education',
    automobileHero: business === 'doctor-clubs'
  }"
>
  <div class="desktopHide mobileSort">
    <div class="row">
      <div
        class="col-md-12 mobileSearch"
        [ngClass]="{
          bgCustomPurple: business === 'restaurant'
        }"
      >
        <div class="input-group">
          <span class="input-group-text lightDarkPurple border-end-0">
            <img
              src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/icons/location-pin.svg"
              class="img-fluid"
              alt="location-icon"
            />
            <span class="font16 font500 ms-1 styled-select">
              <input
                class="form-control customInput lightDarkPurple lightDarkPurple-focus border-0"
                list="datalistOptions2"
                [placeholder]="localityPlaceholder"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                name="searchText"
                [(ngModel)]="searchText"
                (keyup)="getNearBy()"
                (focus)="focusLocation()"
                autocomplete="off"
              />
              <ul
                class="dropdown-menu p-3"
                aria-labelledby="dropdownMenuButton1"
              >
                <li class="lightDarkPurple p-2 rounded customPurple">
                  <img
                    class="img-fluid"
                    src="../../../../assets/instaciti-new-img/Group 17.svg"
                    alt="location"
                  />
                  <span class="locationText" (click)="detectCurrentLocation()"
                    >Detect current location</span
                  >
                </li>
                <ng-container>
                  <p class="font18 font500 customPurple mt-3">Popular cities</p>
                  <ng-container *ngFor="let city of popularCities">
                    <li>
                      <a
                        class="dropdown-item"
                        (click)="selectPopularCity(city)"
                      >
                        <p class="listMuted mb-0">
                          {{ city.LocName }}
                        </p>
                      </a>
                    </li>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="searchText">
                  <p class="font18 font500 customPurple mt-3">
                    Nearby Location
                  </p>
                  <ng-container *ngFor="let city of nearby">
                    <li>
                      <a class="dropdown-item" (click)="selectNearByCity(city)">
                        <p class="listMuted mb-0">
                          {{
                            city.LocName && city.LocName.length > 50
                              ? (city.LocName | slice: 0:48) + ".."
                              : city.LocName
                          }}
                        </p>
                      </a>
                    </li>
                  </ng-container>
                </ng-container>
              </ul>
            </span>
          </span>
          <input
            class="form-control customInput p-3 border-start-0 border-end-0"
            [placeholder]="placeholder"
            (keyup)="search($event)"
            (focus)="focus($event)"
            [matAutocomplete]="keywords"
            [(ngModel)]="selectedKeyWord.Keywd"
            [ngModelOptions]="{ standalone: true }"
          />
          <mat-autocomplete
            #keywords="matAutocomplete"
            (optionSelected)="onChange($event.option.value)"
          >
            <mat-option *ngFor="let item of searchResult" [value]="item">
              {{ item.Keywd }}
            </mat-option>
          </mat-autocomplete>
          <span class="input-group-text bg-white border-start-0"
            ><img
              src="../../../../assets/instaciti-new-img/Vector (5).svg"
              alt="location-icon"
            />
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="row align-self-center">
    <div class="col-md-7 col-12">
      <h1 class="font500">{{ heading }}</h1>
      <p class="font26 font400">
        {{ subHeading }}
      </p>
    </div>
    <div class="col-md-5 col-12">
      <div class="HeroImg float-end">
        <figure>
          <img [src]="bannerImgURL" alt="" class="img-fluid" />
        </figure>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid customGapping collectionBand mb-3">
  <div class="customCard pt-3 pb-3 ps-3 pe-3">
    <div class="scrollMenu">
      <button
        class="btn font16 btn-danger font500 ps-5 pe-5 text-center text-white me-3"
      >
        Collection 1
      </button>
      <button
        class="btn font16 btn-success font500 ps-5 pe-5 text-center text-white me-3"
      >
        Collection 2
      </button>
      <button
        class="btn font16 btn-primary font500 ps-5 pe-5 text-center text-white me-3"
      >
        Collection 3
      </button>
      <button
        class="btn font16 btn-warning font500 ps-5 pe-5 text-center text-white me-3"
      >
        Collection 4
      </button>
    </div>
  </div>
</div>

<div class="container-fluid customGapping desktopSort mb-4">
  <div class="customCard">
    <div class="clearfix">
      <div class="row">
        <div class="col-md-12">
          <nav class="navbar navbar-expand-lg navbar-light cSortNavbar">
            <div class="container-fluid">
              <a class="navbar-brand cSortNav" href="#">SORT BY</a>
              <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-icon"></span>
              </button>

              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                  <li class="nav-item active">
                    <a class="nav-link" href="#">NAME</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#">RATING</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#">PRICE</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#">DISTANCE</a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid customGapping mobileSort mb-4">
  <div class="customCard">
    <div class="sort-by-wrapper clearfix">
      <div class="row">
        <div class="col-6">
          <div class="sortButton d-grid">
            <button
              class="btn btn-primary btn-block btnFilter"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              SORT
            </button>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="sortList mb-2 p-0">
              <li class="nav-item">
                <a class="nav-link customColor font16" href="#">DISTANCE</a>
              </li>
              <li class="nav-item">
                <a class="nav-link customColor font16" href="#">NAME</a>
              </li>
              <li class="nav-item">
                <a class="nav-link customColor font16" href="#">RATING</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-6 text-end">
          <div class="filterButton d-grid">
            <button
              class="btn btn-primary btn-block btnFilter"
              data-bs-toggle="collapse"
              href="#collapseExample"
              role="button"
              aria-expanded="false"
              aria-controls="collapseExample"
            >
              FILTER
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Listing and Sidebar Sections -->

<div class="container-fluid customGapping">
  <div class="row">
    <!-- Mobile Filter -->
    <div class="mobileFilter mb-4">
      <div class="collapse" id="collapseExample">
        <div class="card card-body">
          <div class="sidebarFilter">
            <h4 class="font20 font500 pb-3">Filter Your Result</h4>
          </div>

          <div class="sidebar-module">
            <h5>RATING RANGE</h5>
            <div class="slider-container mt-3 mb-5">
              <label for="rating">({{ rating.value }})</label>
              <input
                type="range"
                #rating
                (input)="(rating.value)"
                id="rating"
                min="0"
                max="100"
              />
            </div>
            <div *ngFor="let category of headers; let idx = index" class="pt-5">
              <ng-container *ngIf="filterData[idx][category]">
                <h5>{{ category }}</h5>
                <div class="checkbox-block font-icon-checkbox">
                  <input
                    id="-1"
                    name="filter_cuisine"
                    type="checkbox"
                    class="checkbox"
                    checked="checked"
                    (change)="filter($event, idx)"
                  />
                  <label class="" for="-1">Any</label>
                </div>
                <ng-container
                  *ngFor="let data of filterData[idx][category]; let i = index"
                >
                  <div *ngIf="i < 4" class="checkbox-block font-icon-checkbox">
                    <input
                      [id]="data.ID"
                      name="filter_cuisine"
                      type="checkbox"
                      class="checkbox"
                      (change)="filter($event, idx)"
                      [checked]="data.checked"
                    />
                    <label class="" for="{{ data.ID }}">{{ data.N }}</label>
                  </div>
                </ng-container>
                <ng-container *ngIf="filterData[idx][category].length > 4">
                  <div class="collapse" id="collapse{{ category }}">
                    <div class="inner">
                      <ng-container
                        *ngFor="
                          let data of filterData[idx][category];
                          let i = index
                        "
                      >
                        <div
                          *ngIf="i >= 4"
                          class="checkbox-block font-icon-checkbox"
                        >
                          <input
                            [id]="data.ID"
                            name="filter_cuisine"
                            type="checkbox"
                            class="checkbox"
                            (change)="filter($event, idx)"
                            [checked]="data.checked"
                          />
                          <label class="" for="{{ data.ID }}">{{
                            data.N
                          }}</label>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <button
                    class="btn btn-more-less"
                    data-bs-toggle="collapse"
                    [attr.href]="'#collapse' + category"
                    role="button"
                    aria-expanded="false"
                    aria-controls="collapseExample"
                  >
                    Show more
                  </button>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile Filter -->

    <div class="col-lg-3 mobileHide">
      <div class="sidebarFilter">
        <h4 class="font20 font500 pb-3">Filter Your Result</h4>
      </div>
      <div class="sidebar-module">
        <h5>RATING RANGE</h5>
        <div class="slider-container mt-3 mb-5">
          <label for="rating">({{ rating.value }})</label>
          <input
            type="range"
            #rating
            (input)="(rating.value)"
            id="rating"
            min="0"
            max="100"
          />
        </div>
        <div *ngFor="let category of headers; let idx = index" class="pt-5">
          <ng-container *ngIf="filterData[idx][category]">
            <h5>{{ category }}</h5>
            <div class="checkbox-block font-icon-checkbox">
              <input
                id="-1"
                name="filter_cuisine"
                type="checkbox"
                class="checkbox"
                checked="checked"
                (change)="filter($event, idx)"
              />
              <label class="" for="-1">Any</label>
            </div>
            <ng-container
              *ngFor="let data of filterData[idx][category]; let i = index"
            >
              <div *ngIf="i < 4" class="checkbox-block font-icon-checkbox">
                <input
                  [id]="data.ID"
                  name="filter_cuisine"
                  type="checkbox"
                  class="checkbox"
                  (change)="filter($event, idx)"
                  [checked]="data.checked"
                />
                <label class="" for="{{ data.ID }}">{{ data.N }}</label>
              </div>
            </ng-container>
            <ng-container *ngIf="filterData[idx][category].length > 4">
              <div class="collapse" id="collapse{{ category }}">
                <div class="inner">
                  <ng-container
                    *ngFor="
                      let data of filterData[idx][category];
                      let i = index
                    "
                  >
                    <div
                      *ngIf="i >= 4"
                      class="checkbox-block font-icon-checkbox"
                    >
                      <input
                        [id]="data.ID"
                        name="filter_cuisine"
                        type="checkbox"
                        class="checkbox"
                        (change)="filter($event, idx)"
                        [checked]="data.checked"
                      />
                      <label class="" for="{{ data.ID }}">{{ data.N }}</label>
                    </div>
                  </ng-container>
                </div>
              </div>
              <button
                class="btn btn-more-less"
                data-bs-toggle="collapse"
                [attr.href]="'#collapse' + category"
                role="button"
                aria-expanded="false"
                aria-controls="collapseExample"
              >
                Show more
              </button>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="col-lg-9">
      <div class="restaurant-list-item-wrapper no-last-bb">
        <div
          *ngFor="let item of listing"
          class="restaurant-list-item clearfix border-bottom mb-5 pb-4"
        >
          <div class="GridLex-grid-noGutter-equalHeight row">
            <div class="col-md-3">
              <div class="businessImage">
                <img
                  *ngIf="item.LogoURL"
                  [src]="item.LogoURL"
                  alt="businessImage"
                  class="img-fluid"
                  (error)="item.LogoURL = null"
                />
                <img
                  *ngIf="!item.LogoURL"
                  src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/not-found.png"
                  alt="businessImage"
                  class="img-fluid"
                />
              </div>
              <div class="instaVerified">
                <img
                  src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/instaciti-verified.png"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>

            <div class="col-md-9">
              <div class="row">
                <div class="col-md-8 content-wrapper">
                  <h5>
                    <a href="javascript:void(0);" class="text-decoration-none">{{
                      item.BUSINESSTITLE
                    }}</a>
                  </h5>
                  <p class="businessLocation">
                    <i
                      class="fa fa-map-marker-alt me-2"
                      [ngClass]="{
                        schoolsColor: business === 'education',
                        listingIconColor: business !== 'education'
                      }"
                      aria-hidden="true"
                    ></i>
                    {{ item.LocalityName }}
                  </p>

                  <ng-container
                    *ngIf="item.PopularAttribs && item.PopularAttribs.length"
                  >
                    <ng-container *ngFor="let attr of item.PopularAttribs">
                      <ng-container [ngSwitch]="attr.ID">
                        <p *ngSwitchCase="'MEDIUM'" class="workHourStatement">
                          <i class="fa-solid fa-graduation-cap me-2 schoolsColor"></i
                          >{{ attr.D }}
                        </p>
                        <!-- <p *ngSwitchCase="'RATING'" class="pricingStatement">
                          <i
                            class="fa-solid fa-graduation-cap me-2 schoolsColor"
                          ></i
                          >{{ attr.D }}
                        </p> -->
                        <p
                          *ngSwitchCase="'ADMNPERIOD'"
                          class="workHourStatement"
                        >
                          <i class="fa-solid fa-id-card-clip me-2 schoolsColor"></i
                          >{{ attr.N }}:
                          {{ attr.D }}
                        </p>

                        <p
                          *ngSwitchCase="'SCHOOLTYPE'"
                          class="cuisineStatement pt-2"
                        >
                          <i
                            class="fa-solid fa-hand-holding me-2 schoolsColor"
                          ></i
                          >{{ attr.D }}
                        </p>
                        <p *ngSwitchCase="'FEE'" class="cuisineStatement pt-2">
                          <i
                            class="fa-solid fa-indian-rupee-sign me-2 schoolsColor"
                          ></i
                          >{{ attr.D }}
                        </p>
                        <p
                          *ngSwitchCase="'CLASSES'"
                          class="cuisineStatement pt-2"
                        >
                          <i
                            class="fa-solid fa-book-open me-2 schoolsColor"
                          ></i
                          >{{ attr.D }}
                        </p>
                      </ng-container>
                      <p *ngIf="attr.ID === 'COSTOF2'" class="pricingStatement">
                        <i class="fas fa-rupee-sign me-2 listingIconColor"></i
                        >Cost for two: {{ attr.D }}
                      </p>
                      <p
                        *ngIf="attr.ID === 'CUISINES'"
                        class="cuisineStatement pt-2"
                      >
                        <i class="fas fa-utensils me-2 listingIconColor"></i
                        ><span *ngFor="let data of attr.D">{{ data }}</span>
                      </p>
                    </ng-container>
                  </ng-container>

                  <!-- <p>Outlets: outlet 1, outlet 2, outlet 3</p> -->
                  <!-- <a href="#" class="cViewListingTxt offer">View Full Menu! </a> -->
                  <!-- <br><br> -->
                </div>

                <div class="col-md-4">
                  <!-- <div class="rating-wrapper text-end">
                    <div class="rating-item">
                      <div
                        class="rating-symbol"
                        style="display: inline-block; position: relative"
                      >
                        <i class="fas fa-star"></i>
                      </div>
                      <div
                        class="rating-symbol"
                        style="display: inline-block; position: relative"
                      >
                        <i class="fas fa-star"></i>
                      </div>
                      <div
                        class="rating-symbol"
                        style="display: inline-block; position: relative"
                      >
                        <i class="fas fa-star"></i>
                      </div>
                      <div
                        class="rating-symbol"
                        style="display: inline-block; position: relative"
                      >
                        <i class="fas fa-star"></i>
                      </div>
                      <div
                        class="rating-symbol"
                        style="display: inline-block; position: relative"
                      >
                        <i class="fas fa-star"></i>
                      </div>
                    </div>
                    <span class="font12"> (27 reviews)</span>
                  </div> -->
                  <img src="https://dkzxkcjlbnjui.cloudfront.net/briefcase/{{item.BusinessHandle}}/bizcard/{{item.BusinessHandle}}.jpg" class="img-fluid">
                  <div class="actionButton pt-2">
                    <!-- <div class="price">Cost for 2: <span>650 - 750Rs.</span> </div> -->
                    <div class="d-grid">
                      <!-- <button
                        (click)="
                          openURL(
                            'https://bizcard.instaciti.com/' +
                              item.BusinessHandle
                          )
                        "
                        class="btn viewSignature"
                      >
                        View Signature
                      </button> -->
                      <!-- <button
                        *ngIf="business !== 'education'"
                        class="btn orderButton mt-3"
                        (click)="openURL(item.HomePageURL)"
                      >
                        Order Now!<i
                          class="fas fa-chevron-circle-right ms-2"
                        ></i>
                      </button> -->
                      <button
                        *ngIf="business !== 'education' && business !== 'doctor-clubs' && business !== 'automative' && business !== 'real-estate'"
                        class="btn orderButton mt-3"
                        (click)="openURL(item.BusinessHandle)"
                      >
                      View BizCard
                      <i class="fas fa-chevron-circle-right ms-2"></i>
                      </button>
                      <button
                        *ngIf="business === 'education' || business === 'doctor-clubs' "
                        class="btn orderButton mt-3"
                        (click)="openSchool(item.BusinessHandle)"
                      >
                        Apply Now!<i
                          class="fas fa-chevron-circle-right ms-2"
                        ></i></button
                      >
                      <a href="https://automobiles.instaciti.com/{{item.BusinessHandle}}/dealer" target="_blank"
                      *ngIf="business === 'automative' || business === 'doctor-clubs'"
                      class="btn orderButton mt-3"
                                          >
                      Visit<i
                        class="fas fa-chevron-circle-right ms-2"
                      ></i></a>
                      <a href="https://realestate.instaciti.com/{{item.BusinessHandle}}/dealer" target="_blank"
                      *ngIf="business === 'real-estate' "
                      class="btn orderButton mt-3"
                                          >
                      Visit<i
                        class="fas fa-chevron-circle-right ms-2"
                      ></i></a><br /><br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<portal-instaciti-footer></portal-instaciti-footer>
